import Bell from "../img/bell.svg?react";
import "./style.scss";
import NiceModal from "@ebay/nice-modal-react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useVisibleMessages } from "../../../api/message/useVisibleMessages";

export default function Controls({ setOpenNav }) {
  const location = useLocation();
  const isUltraInsider =
    location.pathname.includes("/ultra-insider") ||
    location.pathname.includes("/ultrainsider");

  const isQrScanner =
    location.pathname.startsWith("/qr-scanner") ||
    location.pathname.startsWith("/qr-register");

  const { count: visibleCount, isListLoaded } = useVisibleMessages();

  const [activeSkin, setActiveSkin] = useState(() => {
    const stored = localStorage.getItem("activeSkin");
    return stored || null;
  });

  useEffect(() => {
    const updateSkin = () => {
      const stored = localStorage.getItem("activeSkin");
      setActiveSkin(stored || null);
    };

    window.addEventListener("skinChange", updateSkin);
    return () => window.removeEventListener("skinChange", updateSkin);
  }, []);

  return (
    <div className={`navigation-controls ${(activeSkin && !isUltraInsider && !isQrScanner) ? `skin-${activeSkin}` : ""}`}>
      <button
        onClick={() => {
          NiceModal.show("drawer-notifications");
        }}
        className={`noti`}
        aria-label="Notifications-button"
      >
        {isListLoaded && visibleCount > 0 && (
          <div className="counter">
            <span>{visibleCount}</span>
          </div>
        )}
        <Bell />
      </button>
      <button className="open-btn" onClick={() => setOpenNav(true)}>
        <span className="line"></span>
        <span className="line"></span>
        <span className="line"></span>
      </button>
    </div>
  );
}
